import { useEffect, useState } from 'react';

export function OfferCountdownBadge({ expiresAt }: { expiresAt: string | null | undefined }) {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    const interval = window.setInterval(() => setNow(Date.now()), 1000);
    return () => window.clearInterval(interval);
  }, []);
  if (!expiresAt) return <strong>-</strong>;
  const expiry = new Date(expiresAt).getTime();
  if (Number.isNaN(expiry)) return <strong>-</strong>;
  const remaining = Math.max(0, expiry - now);
  if (remaining === 0) return <strong>Reservation expired</strong>;
  const totalSeconds = Math.floor(remaining / 1000);
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;
  return <strong>{String(hours).padStart(2, '0')}:{String(minutes).padStart(2, '0')}:{String(seconds).padStart(2, '0')}</strong>;
}
